export class CollectionUtils {
  static hasCommonElement(set1: Set<any>, set2: Set<any>) {
    for (const element of set1) {
      if (set2.has(element)) {
        return true; // Found a common element
      }
    }
    return false; // No common elements found
  }
}

export function sortNumbersAtEnd(arr: string[]): string[] {
  function startsWithNumber(s: string): boolean {
    return /^\d/.test(s);
  }

  function extractNumber(s: string): number {
    const match = s.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : Infinity;
  }

  const numbers: string[] = arr.filter(startsWithNumber);
  const nonNumbers: string[] = arr.filter(s => !startsWithNumber(s));

  const sortedNumbers: string[] = numbers.sort((a, b) => extractNumber(a) - extractNumber(b));

  return nonNumbers.concat(sortedNumbers);
}
